<div id="overlay">
  <div class="pop-up-container">
    <img
      class="popupimg"
      src="./assets/images/common/fc21_alert_box_gold.webp?t={{ version }}"
    />
    <img
      class="alert-img"
      src="./assets/images/lobby_sprite_images/common/menu_sprite_images/fc21_alert_box_icon.webp?t={{
        version
      }}"
    />

    <img
      class="closeiconImg"
      src="./assets/images/lobby_sprite_images/common/menu_sprite_images/close.webp?t={{
        version
      }}"
      (click)="onCloseClick($event)"
    />
    <div class="lang-specific-text-content-error">
      <div class="lang-specific-font-name">
        {{ errorMessageTranslateCode | translate }}
      </div>
      <div class="lang-secific-font-name">{{ additionalErrorCode }}</div>
    </div>
  </div>
</div>
